import { ABTASTY_QA_PLATFORM_URL } from '@src/shared/constants';

export function onQaAssistantPlatform({ url }: { url: string }) {
  if (typeof url !== 'string' || !url) return;
  sessionStorage.setItem(ABTASTY_QA_PLATFORM_URL, url);
}
